import { render, staticRenderFns } from "./es-svg.vue?vue&type=template&id=67c08eb2"
import script from "./es-svg.vue?vue&type=script&lang=js"
export * from "./es-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports